import React, { Component } from "react"
import styled from "styled-components"

import { SECONDARY_TEXT } from "./consts/colors"

const SectionCenteredContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  width: 95%;
  max-width: 1200px;
  margin: 0px 50px;

  @media (max-width: 900px) {
    margin: 0px;
  }

  @media (max-width: 768px) {
    text-align: center;
    margin: 0px;
    margin-top: 100px;
    width: 70%;
  }

  @media (max-width: 420px) {
    width: 100%;
    top: 50px;
  }
`
const SectionCenteredHeadline = styled.h2`
  width: 90%;
  margin-bottom: 20px;
  text-align: center;
`

const SectionCenteredCopy = styled.p`
  width: 70%;
  margin-bottom: 150px;
  text-align: center;
  font-size: 20px;

  @media (max-width: 768px) {
    width: 50%;
    font-size: 15px;
    margin-bottom: 20px;
  }

  @media (max-width: 615px) {
    width: 60%;
    margin-bottom: 0px;
  }
`

const SectionCenteredContent = props => (
  <SectionCenteredContentWrapper>
    <SectionCenteredHeadline>{props.headline}</SectionCenteredHeadline>
    <SectionCenteredCopy>{props.copy}</SectionCenteredCopy>
    {props.children}
  </SectionCenteredContentWrapper>
)

export default ({ children, headline, copy }) => (
  <SectionCenteredContent headline={headline} copy={copy}>
    {children}
  </SectionCenteredContent>
)



// WEBPACK FOOTER //
// ./src/components/SectionCenteredContent.js